import { React, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Formik, Form, Field } from "formik";

import { getClientUser, addUser } from "../utils/Api";

import * as Yup from "yup";
import ReactPaginate from "react-paginate";
import PlatformNavigation from "./PlatfromNavigation";
import EditClientUser from "./EditClientUser";

import { handleLoaderEvent } from "../utils/LoaderEmitter";

import { iconAssets } from "../assets/theme/theme";
import { Image } from "@fluentui/react-northstar";
import { Modal } from "react-bootstrap";

import "../styles/ViewUsers.css";

const ViewUsers = () => {
  const [addModalShow, setAddModalShow] = useState(false);
  const [users, setUsers] = useState([]);
  const [itemsPerPage, setitemsPerPage] = useState(5);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [currentItems, setCurrentItems] = useState();
  const [addUserStatus, setAddUserStatus] = useState("");
  const [clientName, setClientName] = useState([]);

  let { id } = useParams();

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(users?.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(users?.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, users]);

  useEffect(() => {
    setClientName(localStorage.getItem("clientName"));
    refreshContent();
  }, [addUserStatus]);

  const refreshContent = async () => {
    handleLoaderEvent.emit("loader", true);
    setUsers([]);
    let usersData = await getClientUser(id);
    if (!usersData) {
      return;
    }
    setUsers(usersData.users.reverse());

    handleLoaderEvent.emit("loader", false);
  };

  const addModalHandleClose = () => setAddModalShow(false);

  const addModalHandleShow = () => {
    setAddModalShow(true);
  };

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % users.length;
    setItemOffset(newOffset);
  };

  const userUpdatedHandler = () => {
    refreshContent();
  };

  const userRows = (currentItems) =>
    currentItems?.map((user) => {
      return (
        <>
          <EditClientUser key={user.id} user={user} showEditOption={true} userUpdated={userUpdatedHandler}></EditClientUser>
        </>
      );
    });

  const saveNewUser = async (values) => {
    try {
      let params = {
        firstName: values.firstName,
        lastName: values.lastName,
        phone: null,
        email: values.email,
        country: "India",
        department: values.department,
        loginType: "EMAIL",
        roles: [{ id: 3 }],
        roleIds: [],
        roleMapping: [],
      };
      let addedUser = await addUser(id, params);
      if (!addedUser) {
        return;
      }
      setAddUserStatus(addedUser);
      addModalHandleClose();
      toast.info("User added successfully");
    } catch (exception) {
      toast.error(exception?.response?.data?.message);
    }
  };

  const userTable = () => {
    return (
      <>
        <table className="container-fluid p-0">
          <thead>
            <tr className="mb-4 table-header">
              <th style={{ width: "20%" }}>Name</th>
              <th style={{ width: "15%" }}>Department</th>
              <th style={{ width: "25%" }}>Email</th>
              <th style={{ width: "20%" }}>Assigned Skills</th>
              <th style={{ width: "40%" }}>Actions</th>
            </tr>
          </thead>
          <tbody>{userRows(currentItems)}</tbody>
        </table>
      </>
    );
  };

  const addUserSchema = Yup.object().shape({
    firstName: Yup.string().min(3, "First Name should be atleast 3 characters").required("First Name is Required"),
    lastName: Yup.string().min(3, "Last Name should be atleast 3 characters").required("Last Name is Required"),
    department: Yup.string().min(3, "Department should be atleast 3 characters").required("Department is Required"),
    email: Yup.string().email("Enter valid email id").required("Email is Required"),
  });

  return (
    <>
      <PlatformNavigation id={id} selectedTab={"Manage Users"} clientName={clientName} />
      <div className="row p-0 m-0 screen-header mt-4 mb-3 p-1">
        <div className="col content-title ps-4">Users</div>
        <div className="col-auto cursor" onClick={() => addModalHandleShow()}>
          <div className="row p-0 m-0 cursor-pointer">
            <div className="col-auto pe-1 d-flex align-items-center">
              <Image src={iconAssets.add} alt="" className="add-icon" />
            </div>
            <div className="col-auto ps-0 content-title-sub-text d-flex align-items-center">Add User</div>
          </div>
        </div>
      </div>
      <div className="user-table">{userTable(users)}</div>
      <div className="row p-0 m-0 mt-4">
        <div className="col-auto px-2 d-flex align-items-center">Rows Per Page</div>
        <div className="col-auto px-2 d-flex align-items-center">
          <button className="btn dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
            {itemsPerPage}
          </button>
          <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li>
              <div className="dropdown-item" onClick={() => setitemsPerPage(5)}>
                5
              </div>
            </li>
            <li>
              <div className="dropdown-item" onClick={() => setitemsPerPage(10)}>
                10
              </div>
            </li>
          </ul>
        </div>
        <div className="col p-0 d-flex justify-content-end">
          <ReactPaginate
            nextLabel=">"
            onPageChange={handlePageClick}
            pageRangeDisplayed={4}
            marginPagesDisplayed={2}
            pageCount={pageCount}
            previousLabel="<"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakLabel="..."
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName="pagination"
            activeClassName="active"
            renderOnZeroPageCount={null}
          />
        </div>
      </div>
      <Modal className="edit-modal" show={addModalShow} onHide={addModalHandleClose}>
        <Modal.Body>
          <Modal.Title>Add User</Modal.Title>
          <Formik
            initialValues={{
              firstName: "",
              lastName: "",
              email: "",
              department: "",
            }}
            validationSchema={addUserSchema}
            onSubmit={(values) => {
              saveNewUser(values);
            }}
          >
            {({ errors, touched }) => (
              <Form>
                <div className="row p-0 m-0 w-100">
                  <div className="col-6 ps-0 pe-3 mt-4">
                    <div className="new-input position-relative">
                      <Field name="firstName" type="text" />
                      <span className="floating-label">First Name</span>
                      {errors.firstName && touched.firstName ? <div className="invalid-text">{errors.firstName}</div> : null}
                    </div>
                  </div>
                  <div className="col-6 ps-3 pe-0 mt-4">
                    <div className="new-input position-relative">
                      <Field name="lastName" type="text" />
                      <span className="floating-label">Last Name</span>
                      {errors.lastName && touched.lastName ? <div className="invalid-text">{errors.lastName}</div> : null}
                    </div>
                  </div>
                  <div className="col-6 ps-0 pe-3 mt-4">
                    <div className="new-input position-relative">
                      <Field name="department" type="text" />
                      <span className="floating-label">Department</span>
                      {errors.department && touched.department ? <div className="invalid-text">{errors.department}</div> : null}
                    </div>
                  </div>
                  <div className="col-6 ps-3 pe-0 mt-4">
                    <div className="new-input position-relative">
                      <Field name="email" type="email" />
                      <span className="floating-label">Email Id</span>
                      {errors.email && touched.email ? <div className="invalid-text">{errors.email}</div> : null}
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-center mt-5">
                  <button type="button" className="cancel-button p-2 px-4 me-3" onClick={addModalHandleClose}>
                    Cancel
                  </button>
                  <button type="submit" className="save-button p-2 px-4">
                    Save
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default ViewUsers;
